import React from "react";
import TitleSection from "../titleSection";
import { PrismicRichText } from "@prismicio/react";
import { Accordion } from "react-bootstrap";
import { IoChevronDownOutline } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import * as s from "./index.module.scss";

const FAQSection = ({ data }) => {
  return (
    <div className={`section_wrapper section_color-off ${s.faq_section}`}>
      <TitleSection
        title={data.faq_title}
        description={data.faq_description}
        maxWidth={532}
      />
      <Accordion className={s.faq_wrapper}>
        {data.faqs.map((item, idx) => {
          return (
            <div className="">
              <Accordion.Item
                eventKey={idx}
                key={idx}
                className={s.accordion_item}
              >
                <Accordion.Header
                  className={`${secondaryFont} sub-title ${s.collapsed}`}
                >
                  <PrismicRichText field={item.question} />

                  <span>
                    {" "}
                    <IoChevronDownOutline size="22px" />{" "}
                  </span>
                </Accordion.Header>
                <Accordion.Body
                  className={`${s.faq_answer} ${s.show} sub-title`}
                >
                  <PrismicRichText field={item.answer} />
                </Accordion.Body>
              </Accordion.Item>
            </div>
          );
        })}
      </Accordion>
    </div>
  );
};

export default FAQSection;
